import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from '../../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top";
import FieldManagementForm from "../../../fields3/render/management-form";
import {EntityType} from "../../../gd/const/item";

class ModalEditField extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            entity              : PropTypes.number,
            field               : PropTypes.object,
            disableRequired  : PropTypes.bool,
            onSubmit            : PropTypes.func
        })
    };

    constructor(props) {
        super(props);
    }

    onClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    _getTitle = () => {
        switch (this.props.params.entity) {
            case EntityType.FORM: return 'Edit form field'
            default             : return 'Edit custom field'
        }
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">{this._getTitle()}</div>

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <FieldManagementForm field              = {this.props.params.field}
                                     isNewField         = {false}
                                     disableRequired    = {this.props.params.disableRequired}
                                     entity             = {this.props.params.entity}
                                     onSubmit           = {this.props.params.onSubmit}/>
            </div>
        )
    }
}

module.exports = ModalEditField
